import React, { useEffect, useState } from "react";
import { Icon, Row, Col, Button, InputNumber } from "antd";
import { SelectionMode } from "@models/index";
import PersonSelection from "@components/people/Selection";
import PersonRoleSelection from "@components/person-roles/PersonRoleSelection";
import { VideoContentPersonRole } from "@models/video-content";
import { useImperativeHandle } from "react";
import { forwardRef } from "react";
import { FormattedMessage } from 'react-intl';
import { PersonRole } from '../../models/person-role';

function PersonsRoles(props: Props, ref) {
  const [items, setItems] = useState(props.video_content_person_roles);
  const [deletedItems, setDeletedItems] = useState([]);
  const [personRole, setPersonRole] = useState({});

  useEffect(() => {
    setItems(props.video_content_person_roles);
  }, [props.video_content_person_roles]);

  useImperativeHandle(ref, () => {
    return ({
      value: {
        new_person_roles: items
          .filter(pr => !pr.id)
          .map(newPR => ({
            person_role_id: newPR.person_role.id,
            person_id: newPR.person.id,
            order: newPR.order,
          })),
        deleted_person_roles: deletedItems
      }
    })
  });

  const addPersonRole = () => {
    const _items = [...items, personRole];
    setItems(_items);
    setPersonRole({});
  };

  const removePersonRole = (id, index) => {
    if (id) {
      setDeletedItems([...deletedItems, id]);
    }
    const selecteds = [...items];
    selecteds.splice(index, 1);
    setItems(selecteds);
  };

  const setPerson = person => {
    setPersonRole({
      ...personRole,
      person
    });
  };

  const setRole = (person_role: PersonRole) => {
    setPersonRole({
      ...personRole,
      person_role
    });
  };

  const setOrder = (order: number) => {
    setPersonRole({
      ...personRole,
      order
    });
  }

  return (
    <div className={`selected-with-add-btn person-role-selection`}>
      <Row gutter={24}>
        <Col span={8}>
          <label><FormattedMessage id="app.select_person" defaultMessage={`Select Person`} /></label>
          <PersonSelection
            key={`person-selection-${items.length + 1}`}
            mode={SelectionMode.DEFAULT}
            onChange={setPerson}
          />
        </Col>
        <Col span={8}>
          <label><FormattedMessage id="app.select_role" defaultMessage={`Select Role`} /></label>
          <PersonRoleSelection
            key={`person-role-selection-${items.length + 1}`}
            mode={SelectionMode.DEFAULT}
            onChange={setRole}
          />
        </Col>
        <Col span={8}>
          <label style={{ whiteSpace: 'nowrap' }}><FormattedMessage id="app.display_order" defaultMessage={`Display Order`} /></label>
          <InputNumber
            key={`person-order-${items.length + 1}`}
            min={1}
            onChange={setOrder}
          />
        </Col>
        <Button
          type={`link`}
          disabled={!personRole.person || !personRole.person_role}
          onClick={() => addPersonRole()}
        >
          <Icon type="plus-circle" />
        </Button>
      </Row>
      <div className={`selected-items-badge-list`}>
        {items.map((item, index) => (
          <Row gutter={24} key={index}>
            <Col span={8}>
              <p>{item.person.name}</p>
            </Col>
            <Col span={8}>
              <p> {item.person_role.title}</p>
            </Col>
            <Col span={8}>
              <p>{item.order}</p>
            </Col>
            <Button
              type={`link`}
              onClick={() => removePersonRole(item.id, index)}
            >
              <Icon type="close" />
            </Button>
          </Row>
        ))}
      </div>
    </div>
  );
}

export default forwardRef(PersonsRoles);

interface Value {
  person_with_role_list: object[];
  ids: [];
}

export type PersonsRolesRef = {
  value: Value;
};

type Props = {
  video_content_person_roles: VideoContentPersonRole[];
};
